import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { MenuModule } from 'primeng/menu';

import { environment } from '../environments/environment';
import { version } from '../environments/version';

import { GlobalErrorHandlerService } from './global-error/global-error-handler.service';
import { PushNotificationsService } from './notifications/push-notifications.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, MenuModule, TranslocoModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  envName = environment.ENV_NAME;
  protected readonly globalErrorHandlerService = inject(GlobalErrorHandlerService);
  private pushNotificationsService = inject(PushNotificationsService);
  protected errorOverlayOpen = false;

  version: { hash: string; date: string } = version;

  ngOnInit() {
    console.log(`App initialized in ${this.envName} environment with version:`, this.version);
    void this.pushNotificationsService.init();
  }

  toggleErrorOverlay(): void {
    this.errorOverlayOpen = !this.errorOverlayOpen;
  }

  closeErrorOverlay(): void {
    this.errorOverlayOpen = false;
  }

  clearErrors(): void {
    this.globalErrorHandlerService.clear();
  }

  reloadForRecovery(): void {
    this.globalErrorHandlerService.reloadForRecovery();
  }

  dismissRecoveryDialog(): void {
    this.globalErrorHandlerService.dismissRecoveryDialog();
  }
}
